package com.macrofocus.eflux

enum class Languages(val code: String, val label: String) {
    ENGLISH("en", "English"),
    GERMAN("de", "Deutsch"),
    FRENCH("fr", "Français"),
    ITALIAN("it", "Italiano")
//    ROMANSH("rm", "Rumantsch")
    ;

    operator fun component1() = code
    operator fun component2() = label

    companion object {
        fun valueOfCode(code: String) = values().find { it.code == code }
    }
}
